import * as React from 'react';
import { components } from 'react-select';
import Checkbox from './checkBox';

import { Checkbox, INDETERMINATE, } from '../../index'

const renderCheckbox = (props, label) => {
  const { selectProps } = props;
  const { value, inputValue } = selectProps;
  const anyOptionsAreSelected = !!value.length;
  const allOptionsAreSelected = selectProps.allOptionsAreSelected && !inputValue;

  return (
    <Checkbox
      label={label}
      selected={props.isSelected || allOptionsAreSelected}
      state={props.data.value === 'All' && anyOptionsAreSelected && !allOptionsAreSelected ? INDETERMINATE : null}
    />
  )
};

export const CheckableDropdownOption = (props) => {
  const { data, innerProps, selectProps, } = props;

  const modifiedInnerProps = {
    ...innerProps,
  };

  if (selectProps.options.length > 100) {
    // improves performance with very large lists, see https://github.com/JedWatson/react-select/issues/3128 for discussion
    delete modifiedInnerProps.onMouseMove;
    delete modifiedInnerProps.onMouseOver;
  }

  return (
    <components.Option {...props} innerProps={modifiedInnerProps}>
      <span className="checkable-dropdown-option">
        {renderCheckbox(props, data.label)}
      </span>
    </components.Option>
  );
};
